import { useState, useEffect } from "react";
import BackMethods from "../../back_component/BackMethods";
import { useNavigate, useLocation } from "react-router-dom";

export default function FacilityTypeManagementPage() {
    const location = useLocation();
    const successMessage = location.state?.successMessage;
    const [deleteSuccessMessage, setDeleteSuccessMessage] = useState("");
    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();

    const [facilityTypes, setFacilityTypes] = useState([]);
    const [filteredTypes, setFilteredTypes] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    // جلب البيانات من السيرفر
    const fetchFacilityTypes = async () => {
        try {
            const res = await backEnd_request.get("/FacilityTypes");
            setFacilityTypes(res.data);
            setFilteredTypes(res.data);
        } catch (error) {
            console.log(error.response?.data || error);
        }
    };

    useEffect(() => {
        fetchFacilityTypes();
    }, []);

    // البحث
    const handleSearch = (term) => {
        setSearchTerm(term);

        if (!term.trim()) {
            setFilteredTypes(facilityTypes);
            return;
        }

        const filtered = facilityTypes.filter((type) =>
            type.name.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredTypes(filtered);
    };

    // الحذف
    const handleDelete = async (facilityTypeId) => {
        if (window.confirm("هل أنت متأكد من حذف هذا النوع؟")) {
            try {
                await backEnd_request.delete(
                    `/FacilityTypes/${facilityTypeId}`
                );
                fetchFacilityTypes();
                setDeleteSuccessMessage("تم حذف نوع المنشأة بنجاح ✅");
                setTimeout(() => setDeleteSuccessMessage(""), 3000);
            } catch (error) {
                console.log(error.response?.data || error);
            }
        }
    };

    return (
        <div className="container py-5">

            {/* العنوان + زر الإضافة */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h3 className="fw-bold text-primary">إدارة أنواع المنشآت</h3>

                <button
                    className="btn btn-success"
                    onClick={() => navigate("/admin/facilitytypes-management/create")}
                >
                    <i className="bi bi-plus-circle"></i> إضافة نوع
                </button>
            </div>

            {/* رسائل النجاح */}
            {successMessage && (
                <div className="alert alert-success text-center fw-bold">
                    {successMessage}
                </div>
            )}

            {deleteSuccessMessage && (
                <div className="alert alert-success text-center fw-bold">
                    {deleteSuccessMessage}
                </div>
            )}

            {/* البحث */}
            <div className="card shadow-sm mb-4 p-3">
                <div className="row g-3 align-items-center">
                    <div className="col-md-6">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="اكتب هنا للبحث..."
                            value={searchTerm}
                            onChange={(e) => handleSearch(e.target.value)}
                        />
                    </div>

                    <div className="col-md-3">
                        <button
                            className="btn btn-outline-secondary w-100"
                            onClick={() => {
                                setSearchTerm("");
                                setFilteredTypes(facilityTypes);
                            }}
                        >
                            إعادة تعيين
                        </button>
                    </div>
                </div>
            </div>

            {/* الجدول */}
            <div className="table-responsive shadow-sm">
                <table className="table table-hover align-middle text-center">
                    <thead className="table-primary">
                        <tr>
                            <th>اسم النوع</th>
                            <th>إجراءات</th>
                        </tr>
                    </thead>

                    <tbody>
                        {filteredTypes.length > 0 ? (
                            filteredTypes.map((item) => (
                                <tr key={item.facilityTypeId}>
                                    <td
                                        className="text-primary fw-bold"
                                        style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                        onClick={() => navigate(`/admin/establishments-list?facilityType=${encodeURIComponent(item.name)}`)}
                                    >
                                        {item.name}
                                    </td>

                                    <td>
                                        <button
                                            className="btn btn-sm btn-outline-primary me-2"
                                            onClick={() => navigate(`/admin/facilitytypes-management/edit/${item.facilityTypeId}`)}
                                        >
                                            <i className="bi bi-pencil-square"></i>
                                        </button>
                                        <button
                                            className="btn btn-sm btn-outline-danger"
                                            onClick={() =>
                                                handleDelete(item.facilityTypeId)
                                            }
                                        >
                                            <i className="bi bi-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="2" className="text-muted py-4">
                                    لا توجد بيانات لعرضها
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
